import { render } from "./AccessEmployeeSearchScreen.vue?vue&type=template&id=50a5bf44"
import script from "./AccessEmployeeSearchScreen.vue?vue&type=script&lang=js"
export * from "./AccessEmployeeSearchScreen.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__